module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagex",
      "title": "x"
    }
  }), _vm._v("InterVarsity Press"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Robert A. Fryling")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Associate Publisher, Editorial")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cindy Bunch")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Editorial Director, Academic")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Daniel G. Reid")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('i', [_vm._v("Production Director")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Anne Gerth")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexi",
      "title": "xi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96d81d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/IVP.vue
// module id = 66
// module chunks = 0